import React from 'react';



const Home = () => {
    

 

    return (
        <div id='home' className='h-[100vh] lg:p-0 p-5 lg:text-start'>
           
            <div>
                <div className='lg:mt-[10%] mt-[20%]'>
                    <h1 className='text-white font-bold text-4xl text-center'><span className='text-red-400'>Hello I'm</span> MD. Shamim</h1>
                    <div className='text-center'>
                        <p className='text-white font-semibold text-xl mt-5'>I'm a passionate <span className='text'>
                            <a href="#" class="typewrite" data-period="2000" data-type='[ "MERN Stack Developer", "Full Stack Developer", "Front End Stack Developer", "React Developer" ]'>
                                <span class="wrap"></span>
                            </a>
                        </span> </p>
                        <p className='text-white font-semibold text-xl mt-5'>From Bangladesh</p>
                        <p className='text-white font-semibold text-xl mt-5 lg:w-2/4 mx-auto text-justify'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam similique nam delectus ipsa cumque! Tenetur temporibus omnis sit aut recusandae.</p>
                    </div>
                    <div className='mt-10 social-links  flex lg:justify-center justify-center'>
                        <a href="https://www.facebook.com/profile.php?id=100079276504866" class="facebook" data-aos="slide-up"><i class="fa-brands fa-facebook"></i></a>
                        <a href="https://www.linkedin.com/in/flshamim/" class="instagram" data-aos="slide-down"><i class="fa-brands fa-linkedin"></i></a>
                        <a href="https://github.com/shamimfl" class="linkedin" data-aos="slide-up"><i class="fa-brands fa-github"></i></a>
                    </div>
                </div >
            </div>

            {/* modal  */}
            

        </div >
    );
};

export default Home;